module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAn0lEQVQ4T62TQQrCQAxF/79e6AFE0K51IXgEz+CiBxDxBM2hhF7ByIiKnU46QTqrLPJf8pMMe9U7gaOIXBF8qrp7AGumwIAzgTYC+OTDbMtULArI817iCKBU4CueA3idjcQlwJylifgXALMLyI03zKL4DbgZsDKga0T2pS0uWzn3GPbsJVanXTsUd881oXdIf992Wh971YHAIfIpsg5OTy7QofSgTjeJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/close.png
// module id = hSZV
// module chunks = 1